import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import BreadCrumb from '../../common/breadcrumb/breadCrumb';
import { all_routes } from '../../../../core/data/routes/all_routes';

const TermsCondition = () => {
  const routes = all_routes;
  useEffect(() => {
    window.scrollTo(0, 0); // Ensure page scrolls to top
    AOS.init({ duration: 1000, once: true }); // Optional if using AOS
  }, []);

  return (
    <>

      {/* Breadcrumb */}
      <BreadCrumb title='Terms & Conditions' item1='Home' item2='Terms & Conditions' />
      {/* /Breadcrumb  r*/}
      <div className="page-wrapper">
        <div className="content">
          <div className="container">
            <div className="row">
              {/* Terms & Conditions */}
              <div className="col-md-12">
                <div className="terms-content privacy-cont">
                  <p>
                    Data/information provided to us during sign-up / registering or using our Platform such as name, date of birth, address, telephone/mobile number, email ID and/or any such information shared as proof of identity or address. Some of the sensitive personal data may be collected with your consent, such as your bank account or credit/debit card or other payment instrument information or biometric information such as your facial features or physiological information (in order to enable use of certain features when opted for, available on the Platform), all of the above being in accordance with applicable law(s).
                  </p>
                  <p>
                    You always have the option to not provide information, by choosing not to use a particular service or feature on the Platform. We may track your behaviour, preferences, and other information that you choose to provide on our Platform. This information is compiled and analysed on an aggregated basis. We will also collect your information related to your transactions on Platform and such third-party business partner platforms. When such a third-party business partner collects your personal data directly from you, you will be governed by their privacy policies. We shall not be responsible for the third-party business partner’s privacy practices or the content of their privacy policies, and we request you to read their privacy policies prior to disclosing any information.
                  </p>
                  <p>
                    If you receive an email, a call from a person/association claiming to be MAHINCHA IT SOLUTIONS LLP seeking any personal data like debit/credit card PIN, net-banking or mobile banking password, we request you to never provide such information. If you have already revealed such information, report it immediately to an appropriate law enforcement agency.
                  </p>
                  <h5>Usage</h5>
                  <p>
                    We use personal data to provide the services you request. To the extent we use your personal data to market to you, we will provide you the ability to opt-out of such uses. We use your personal data to assist sellers and business partners in handling and fulfilling orders; enhancing customer experience; resolving disputes; troubleshooting problems; informing you about offers and updates; customizing your experience; detecting and protecting against fraud or criminal activity; enforcing terms; and for research and analysis purposes.
                  </p>
                  <h5>Sharing</h5>
                  <p>
                    We may share your personal data within our group entities, corporate entities, and affiliates. These entities may market to you unless you explicitly opt-out. We may disclose data to sellers, service providers (logistics, payment, etc.), or law enforcement, as required to fulfill our services or comply with legal obligations.
                  </p>
                  <h5>Security Precautions</h5>
                  <p>
                    We adopt reasonable security practices to protect your data. However, data transmission over the internet cannot be guaranteed as completely secure. Users must ensure the protection of their login credentials.
                  </p>
                  <h5>Data Deletion and Retention</h5>
                  <p>
                    You can delete your account via profile settings. We may delay deletion if there are pending claims or services. Data may be retained in anonymized form for analytics and research, or longer if required by law.
                  </p>
                  <h5>Your Rights</h5>
                  <p>
                    You may access, rectify, and update your personal data via Platform functionalities.
                  </p>
                  <h5>Consent</h5>
                  <p>
                    By using the Platform, you consent to the use and processing of your data in accordance with this policy. If you provide data of others, you confirm you have their consent. You can withdraw consent by writing to our Grievance Officer.
                  </p>
                  <h5>Changes to this Privacy Policy</h5>
                  <p>
                    This Privacy Policy may be updated from time to time. Please check periodically.
                  </p>
                  <h5>Refund Policy</h5>
                  <p>
                    We are not providing any kind of refund.
                  </p>
                  <div className="terms-btn">
                    <Link to="#" className="btn btn-light me-3">
                      Not right now...
                    </Link>
                    <Link to="#" className="btn btn-dark">
                      I agree with terms
                    </Link>
                  </div>
                </div>
              </div>

              {/* /Terms & Conditions */}
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default TermsCondition;
